import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../css/others/Table.css";
import Pagination from "../../Reusablecomponents/Pagination";
import { apiCall } from "../../main/ApiCall";
import { FunctionGlobalChecklistDetails } from '../../interFaces/interfaces';
const GlobalFunctionDetails: React.FC = () => {
  const { functionTemplateId } = useParams<{ functionTemplateId: string }>();
  const [details, setDetails] = useState<FunctionGlobalChecklistDetails | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0); 
  useEffect(() => {
    const fetchChecklistDetails = async () => {
      if (!functionTemplateId) return;
      setLoading(true);
      try {
        const checklist = await apiCall("get", `/api/function-template/base-templates/${functionTemplateId}/questions`, null, { page: currentPage - 1, size: itemsPerPage, });
        setDetails(checklist || { content: [] });
        setTotalElements(checklist.totalElements || 0);
        setTotalPages(checklist.totalPages || 0);
      } catch (error) {
        console.error("Error fetching checklist details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchChecklistDetails();
  }, [functionTemplateId, currentPage, itemsPerPage]);
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Global Function Checklist Details</h2>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No.</th><th>Function Area</th><th>Question</th><th>Evidence Required</th><th>ISO Clause Ref</th><th>Annex A Control Ref</th>
              </tr>
            </thead>
            <tbody>
              {details?.content && details.content.length > 0 ? (
                details.content.map((item: any, index: number) => (
                  <tr key={item.questionId || index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.functionAreaName || "Empty"}</td>
                    <td>{item.questionText || "Empty"}</td>
                    <td>{item.evidenceRequired || "Empty"}</td>
                    <td>{item.isoClauseReference || "Empty"}</td>
                    <td>{item.annexAControlReference || "Empty"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no-data" colSpan={6}>No questions available for this Function checklist</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default GlobalFunctionDetails;